import { Button } from "@remo-co/ui-core/src/components/Button";
import { useI18n } from "i18n";
import { ComponentPropsWithRef } from "react";
import { useStyles } from "../../styles";

type ButtonProps = Omit<ComponentPropsWithRef<typeof Button>, "onError">;

interface Props extends ButtonProps {
  url: string;
}

export const ImageButton = ({ url, ...rest }: Props) => {
  const styles = useStyles();
  const { t } = useI18n(["videoBackground"]);
  return (
    <Button
      {...rest}
      className={styles.button}
      variant="secondary"
      color="dark"
      size="xs"
      contentClassName={styles.buttonContent}
    >
      <img
        src={url}
        className={styles.backgroundImage}
        alt={t("videoBackground:virtual.background")}
        data-testid="background-image"
      />
    </Button>
  );
};
